import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";
import { useHackathon } from "../contexts/HackathonContext";
import { groups } from "../data/groups";
import { PageHeader } from "../components/PageHeader";
import { Avatar } from "../components/Avatar";
import { groupProgress } from "../utils/progress";
import { subjectForGroup } from "../utils/subjects";
export function Groups() {
  const {
    state
  } = useHackathon();
  return <main className="mx-auto max-w-6xl px-5 py-10 md:px-8 md:py-12" data-id="element-879" data-mp="1y6a244133323">
      <PageHeader title="Groups" description="Five cross-border teams. Open a group to see daily videos, milestones and the product brief." data-id="element-880" data-mp="1y60e2lzln5z1" />

      <ul className="mt-8 divide-y divide-line rounded-xl border border-line bg-surface" data-id="element-881" data-mp="2781716nsv5uw">
        {groups.map(g => {
        const members = state.students.filter(s => s.groupId === g.id);
        const mentors = state.mentors.filter(m => m.groupIds.includes(g.id));
        const profile = state.groups.find(p => p.id === g.id);
        const p = groupProgress(profile, state.videos, g.id);
        const subject = subjectForGroup(g.id);
        return <li key={g.id} data-id="element-882" data-mp="2fcen9qr4wc00">
              <Link to={`/organizer/groups/${g.id}`} className="grid items-center gap-4 px-5 py-4 transition-colors duration-150 hover:bg-paper md:grid-cols-[110px_1fr_240px_180px_20px]" data-id="element-883" data-mp="2fc6cq5ihhirz">
                <div data-id="element-884" data-mp="2o7mc1220cq4y">
                  <p className="text-lg font-bold" data-id="element-885" data-mp="2t431q0ouvck5">Group {g.id}</p>
                  {mentors.length > 0 && <p className="truncate text-xs text-muted" data-id="element-886" data-mp="2y2wbpj4xolfk">
                      Mentor{mentors.length > 1 ? "s" : ""}: {mentors.map(m => m.name.split(" ")[0]).join(", ")}
                    </p>}
                </div>
                <div className="min-w-0" data-id="element-887" data-mp="13r9b1fzd1qr9">
                  <p className="truncate text-[15px] font-semibold" data-id="element-888" data-mp="18o80hl82x9j4">
                    {profile?.productName || <span className="font-normal text-muted" data-id="element-889" data-mp="10njxbift03n0">Product not named yet</span>}
                  </p>
                  <p className="truncate text-sm text-muted" data-id="element-890" data-mp="vp8mp5hopp3q">{subject ?? "Track not assigned"}</p>
                </div>
                <div className="flex items-center gap-2" data-id="element-891" data-mp="1an10nt7l25ft">
                  <div className="flex -space-x-2" data-id="element-892" data-mp="15mwlc6ievgr6">
                    {members.map(m => <span key={m.id} className="rounded-full ring-2 ring-surface" data-id="element-893" data-mp="1jmo5yq3fnve5">
                        <Avatar name={m.name} school={m.school} photo={m.photo} size="sm" data-id="element-894" data-mp="1jkl7ris4mvyc" />
                      </span>)}
                  </div>
                  <span className="truncate text-sm text-muted" data-id="element-895" data-mp="1tb62gv4ojgbz">{members.map(m => m.name.split(" ")[0]).join(", ")}</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-896" data-mp="22d5ibk3ykedc">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-line" data-id="element-897" data-mp="22dp1f45ch8sy">
                    <div className="h-full rounded-full bg-brgreen" style={{
                  width: `${p.percent}%`
                }} data-id="element-898" data-mp="1yclputubxyxj" />
                  </div>
                  <span className="w-10 text-right text-sm font-semibold tabular-nums" data-id="element-899" data-mp="2h0nu12fxu999">{p.percent}%</span>
                </div>
                <ChevronRightIcon className="hidden h-4 w-4 text-muted md:block" aria-hidden="true" data-id="element-900" data-mp="27z6d5hupi3ji" />
              </Link>
            </li>;
      })}
      </ul>
    </main>;
}